module.exports = {"TXTINT_BRAND_BetStars":{"id":"TXTINT_BRAND_BetStars","defaultMessage":"PokerStars Sports"}}